import React from 'react';
import Column from "@Containers/components/Column";
import NoResultsMessage from "@SearchResults/features/noResults/components/NoResultsMessage";
import {TransfersDataType} from "@SearchResults/features/banners/features/getByTransferBanner/types/TransfersData.type";
import useGbtBanner from "@SearchResults/features/banners/features/getByTransferBanner/hooks/useGbtBanner";
import ParamsType from "@SearchResults/types/params/Params.type";
import SearchResultsUrlsType from "@SearchResults/types/urls/SearchResultsUrls.type";
import {
    GetByFerryDataType
} from "@SearchResults/features/banners/features/getByTransferBanner/types/GetByFerryData.type";
import NoResultsWithGbtPromo from "@SearchResults/features/noResults/components/NoResultsWithGbtPromo";
import NoResultsNotice from "@SearchResults/features/noResults/components/NoResultsNotice";
import hasNoDirectRoutes from "@SearchResults/features/noResults/functions/hasNoDirectRoutes";

interface NoResultsProps {
    getByFerryData: GetByFerryDataType,
    transfersData: TransfersDataType,
    urls: SearchResultsUrlsType,
    params: ParamsType,
}

function NoResults({urls, params, getByFerryData, transfersData}: NoResultsProps) {
    const {
        gbtShowBanner,
        gbtShowNoDirectRoutesNotification,
    } = useGbtBanner({transfersData, getByFerryData, numberOfResults: 0})

    const {noDirectRoutes} = hasNoDirectRoutes(transfersData, params)

    return (
        <>
            {gbtShowBanner && (
                <NoResultsWithGbtPromo
                    params={params}
                    transfersData={transfersData}
                    showNoDirectRoutesNotification={gbtShowNoDirectRoutesNotification}
                />
            )}
            <Column className="no-results__content" reverse={noDirectRoutes && !(!getByFerryData && gbtShowBanner)}>
                {!getByFerryData && gbtShowBanner ? (
                    <NoResultsNotice
                        params={params}
                        urls={urls}
                        smallTitle
                    />
                ) : (
                    <NoResultsMessage
                        params={params}
                        urls={urls}
                        toCityName={transfersData?.toName ?? ""}
                        nearByCityName={noDirectRoutes ? transfersData?.departureNearbyCity?.name : ""}
                        showNoDirectRoutes={noDirectRoutes}
                    />
                )}
            </Column>
        </>
    );
}

export default NoResults;
